<template>
  <!-- <div>
        <div class="col-md-8 col-lg-8 offset-md-2 offset-lg-2 page">
            <div class="form" ref="formContainer">
                <h1 class="profile__header mt-md-0 mt-0">REGISTERED DEVICES</h1>
            </div>
        </div> -->
  <div class="col-md-8 col-lg-8 offset-md-2 offset-lg-2 page">
    <div class="device__list">
      <h1 class="list__header mt-md-0 mt-0">DEVICE LIST</h1>
      <div class="gridarea">
        <div class="container">
          <div class="columntop">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
              <span id="col1" class="coltext">Source</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
              <span id="col2" class="coltext">Type</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-5 top-col">
              <span id="col3" class="coltext">Serial Number</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-col">
              <span id="col4" class="coltext">Extension</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
              <span id="col5" class="coltext">Gateway</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
              <span id="col8" class="coltext"></span>
            </div>
          </div>
          <h2 v-if="currentMeters.length == 0" class="no__devices">NO DEVICES REGISTERED</h2>

          <div v-else v-for="meter in currentMeters" class="columnrow" :key="meter.meterid">
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
              <span id="meterSource" class="coltext">Fora</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
              <span id="meterType" class="coltext">{{
                meter.MeterName._cdata + ' (' + meter.MeterType._text + ')'
              }}</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-5 top-row-device">
              <span id="meterId" class="coltext">{{
                meter.MeterID._text
              }}</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-1 top-row-device">
              <span id="meterEx" class="coltext">{{
                meter.MeterExID._text
              }}</span>
            </div>
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row-device">
              <span id="meterGateway" class="coltext">{{
                meter.GatewayID._text
              }}</span>
            </div>
            <!-- <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
              <span id="cpt" class="coltext">
                <select @change="confirmCpt($event, meter.MeterID._text)">
                  <option selected value=""></option>
                  <template v-if="meter.MeterType._text == 'TD7015'">
                    <option v-for="(value, key, index) in validCpts(nebCptCost, attachedCpts.cptList[meter.MeterID._text])" :key="index+'neb'" :value="key">
                      {{ key }}
                    </option>
                  </template>
                  <template v-else>
                    <option v-for="(value, key, index) in validCpts(regCptCost, attachedCpts.cptList[meter.MeterID._text])" :key="index+'reg'" :value="key">
                      {{ key }}
                    </option>
                  </template>
                </select>
              </span>
            </div> -->
            <!-- <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device cpt-list">
              <template v-if="attachedCpts.cptList[meter.MeterID._text]">
                <a v-for="code in attachedCpts.cptList[meter.MeterID._text]" :key="code" id="oldCpts" class="coltext"
                data-bs-toggle="collapse" href="#cptInfo" role="button" aria-expanded="false" aria-controls="cptInfo" @click="showCptDesc(meter.MeterID._text, code)">
                  {{ code }}
                </a>
              </template>
            </div> -->
            <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row-device">
              <button class="meter__delete"
                @click="deleteMeter(meter.MeterType._text, meter.MeterID._text, meter.MeterExID._text)">Remove Device</button>
            </div>
          </div>
        </div>
        <div class="collapse" id="cptInfo">
          <div class="card card-body">
            <cpt-desc :currentInfo="focusedCurCpt" :historicalInfo="focusedHistCpt" :measurements="measurements"/>
          </div>
        </div>
      </div>
    </div>
    <div class="form" ref="formContainer">
      <form @submit.prevent="handleSubmit()" id="form_device">
        <h1 class="device__header mt-md-0 mt-0">ADD A DEVICE</h1>

        <div class="row">
          <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
            <label for="deviceSource" class="device__label">Device Source: </label>
            <select id="deviceSource" v-model="form.deviceSource" class="form-control col-md-6">
              <option v-for="(device, index) in deviceSources" :key="index" :value="device">{{ device }}</option>
            </select>
          </div>

          <template v-if="form.deviceSource != 'N/A'">

            <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
              <label for="deviceType" class="device__label">Device Type: </label>
              <select id="deviceType" v-model="form.deviceType" class="form-control col-md-6">
                <option v-for="(value, key) in deviceTypes" :key="key" :value="value">{{ key }}</option>
              </select>
            </div>

            <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
              <label for="deviceId" class="device__label">Serial Number: </label>
              <input id="deviceId" type="text" v-model="form.deviceId" class="form-control col-md-6"
                @change="validateDeviceId(form.deviceId)">
              <form-error :errors="formErrors.deviceId" />
            </div>

            <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
              <label for="deviceExId" class="device__label">Device Extension: </label>
              <select id="deviceExId" v-model="form.deviceExId" class="form-control col-md-6">
                <option v-for="x in 4" :key="x" :value="x">{{ x }}</option>
              </select>
            </div>

            <div class="col-md-3 col-lg-3 col-sm-6 col-6 form-group">
              <label for="gatewayId" class="device__label">Gateway Id: </label>
              <input id="gatewayId" type="text" v-model="form.gatewayId" class="form-control col-md-6">
            </div>

          </template>
        </div>
        <div class="btn-container">
          <button class="btn btn-primary float-end devices add" type="button" @click="registerDevice"> ADD </button>
        </div>
      </form>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import { CURR_API, OTHER_API } from '@/constants/apis'
import { createDevice } from "@/api/userApi";
import FormError from "../public-layouts/register/FormError.vue"
import VALIDATION_ERRORS from '@/data/validationErrors';
import axios from 'axios'
import { mapGetters } from 'vuex';
import CptDesc from '../private-layouts/CptDesc.vue'
import {
  getFormattedMeters
} from "@/data/getters";
import { xml2js } from 'xml-js'
// import { getStates, getPhoneTypes } from '@/data/getters.js';
export default {
  name: "user-devices",
  components: {
    'form-error': FormError,
    'cpt-desc': CptDesc
  },
  props: ['restricted'],
  data() {
    return {
      currentMeters: [],
      deviceSources: ['N/A', 'Fora'],
      deviceTypes: {
        'D40': 'TD3261',
        'SootheNeb NBL300': 'TD7015',
        'IR20/IR21': 'TD1261',
        'IR42b': 'TD1242',
        'TNG BP': 'TD3140',
        'Test N Go (DM30)': 'TD4283',
        'TN\'G SPO2': 'TD8255',
        'TN\'G Scale 550': 'TD2555'
      },
      form: {
        deviceSource: 'N/A',
        deviceType: '',
        deviceId: '',
        deviceExId: '',
        gatewayId: ''
      },
      regCptCost: {
        '99453': 0,
        '99454': 0,
        '99457': 0,
        '99458': 0,
        '99091': 0
      },
      nebCptCost: {
        '98975': 19.38,
        '98976': 55.72,
        '98980': 50.18,
        '98981': 40.84
      },
      attachedCpts: {},
      cptList: {},
      formErrors: {},
      focusedCurCpt: {},
      focusedHistCpt: {},
      measurements: []
    }
  },
  computed: {
    ...mapGetters('login', {
      allData: 'getAllData'
    }),
  },
  created() {
    // initialize errors
    for (let key in this.form) {
      this.$set(this.formErrors, key, []);
    }
    this.getDevices()
    this.getCpts()
    // console.log(this.meters)
  },
  methods: {
    validate() {
      if (this.form.deviceSource == "N/A") {
        this.formErrors.deviceId = []
      }
      for (let key in this.formErrors) {
        if (this.formErrors[key]
          && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    validateDeviceId(deviceId) {
      this.formErrors.deviceId = []
      if (deviceId.length != 16 && deviceId.length != 0) {
        this.$set(this.formErrors.deviceId, this.formErrors.deviceId.length, VALIDATION_ERRORS.INVALID_DEVICE_ID)
      }
    },
    async showCptDesc(meterid, cptCode){
      let content = {
          "PatientCpt": {
              "API_Meth": "GetMeasurements",
              "pid": this.allData.patient.externId,
              "meterid": meterid
          }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
      .then((res) => {
          if (res.data.status === "Success")
            this.measurements = res.data.data
          this.focusedCurCpt = this.attachedCpts.current[meterid][cptCode]
          this.focusedHistCpt = this.attachedCpts.historical[meterid] ? this.attachedCpts.historical[meterid][cptCode] : {}
          this.focusedHistCpt ? this.focusedHistCpt[this.focusedCurCpt.fid] = this.focusedCurCpt : {}
      })
    },
    validCpts(cptList, addedCpts){
      let listClone = {...cptList}
      if (addedCpts){
        addedCpts.forEach(cpt => {
          delete listClone[cpt]
        })
      }
      return listClone
    },
    async getCpts() {
      let content = {
        "PatientCpt": {
          "API_Meth": "GetPatientCpt",
          "pid": this.allData.patient.externId
        }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
        .then((res) => {
          // console.log(res)
          let arr = res.data
          this.$set(this, 'attachedCpts', arr)
          // console.log(this.attachedCpts)
        })
    },
    async confirmCpt(event, meterid) {
      let selected = event.target.value
      if (!selected)
        return
      let cost = this.nebCptCost[selected] ? this.nebCptCost[selected] : this.regCptCost[selected]
      let content = {
        "PatientCpt": {
          "API_Meth": "AddPatientCpt",
          "pid": this.allData.patient.externId,
          "meterid": meterid,
          "cpt": selected,
          "cost": cost,
          "status": 0,
        }
      }
      let supplyWarning = ""
      if (selected === "99454" || selected === "98976")
        supplyWarning = "\nYou MUST have supplied this device in order to bill for this code, to do so otherwise is insurance fraud."
      if (confirm("Would you like to apply CPT code " + selected + " to this device?" + supplyWarning)) {
        await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          .then((res) => {
            if (!res.data.status)
              alert("Error: Please contact an administrator")
            else if (res.data.status === "Success")
              this.getCpts()
            else
              alert(res.data.status)
          })
        event.target.value = ""
      }
    },
    async deleteMeter(metertype, meterid, meterexid) {
      let content = {
        "RemovePatientInfo": {
          "API_Meth": "RemovePatientDevice",
          "pid": ("" + this.allData.patient.externId).length == 7 ? "0" + this.allData.patient.externId : "" + this.allData.patient.externId,
          "metertype": metertype,
          "meterid": meterid,
          "meterexid": meterexid
        }
      }
      if (confirm("Would you like to delete this device with the serial number " + meterid + "?")) {
        await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          .then((res) => {
            if (!res.data.ReMsg) {
              window.location.reload()
            }
            else {
              alert("Error: " + res.data.ReMsg)
            }
          }, error => {
            alert("Error: Check the console log")
            console.log(error)
          })
      }

    },
    async getDevices() {
      let content = {
        "GetPatientInfo": {
          "API_Meth": "GetPatientDevice",
          "pid": ("" + this.allData.patient.externId).length == 7 ? "0" + this.allData.patient.externId : "" + this.allData.patient.externId
        }
      }
      await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
        .then((res) => {
          let xml = res.data.ReMsg
          if (!xml) return
          let json = xml2js(xml, { compact: true })
          let meters = json['QueryResult']['ReData'] ? json['QueryResult']['ReData']['CaseMeterData']['Meter'] : []
          if (Array.isArray(meters)) {
            this.currentMeters = meters
          }
          else if (typeof meters === "object") {
            this.currentMeters = [meters]
          }
        }, error => {
          console.log(error)
        })
    },
    async registerDevice() {
      if (!this.validate()) {
        alert('Please correct the errors in the form before submitting.');
        return;
      }
      let loader = this.$loading.show({}, {
        after: this.$createElement('div', {}, ['Registering your device with ' + this.form.deviceSource + '...'])
      });

      let patient = this.allData.patient
      if (this.form.deviceSource == "Fora") {
        let content = {
          "AddPatientInfo": {
            "API_Meth": "AddPatientInformation",
            "pid": ("" + patient.externId).length == 7 ? "0" + patient.externId : "" + patient.externId,
            "paccount": ("PACM" + this.allData.user.userName).substring(0, 20),
            "ppassword": 'pAcM' + patient.externId,
            "psaid": "E01",
            "ptz": "T0002",
            "pname": patient.firstName + ' ' + patient.lastName,
            "pbday": "",
            "psex": patient.gender[0] == 'Male' ? '0' : '1',
            "pheight": 159,
            "pweight": 60,
            "ptel1": "",
            "ptel2": "",
            "pemail": patient.email,
            "paddr": "",
            "prace": "",
            "metertype": this.form.deviceType,
            "meterexid": this.form.deviceExId + '',
            "meterid": this.form.deviceId,
            "gatewayid": this.form.gatewayId
          }
        }
        // console.log(content)
        await axios.post(CURR_API + "/tswebhook.php", content, { headers: { 'Content-Type': 'application/json;' } })
          .then(async (res) => {
            // console.log(res)
            if (res.data.ReCode[0] == '00') {
              if (this.form.deviceId) {
                let meterDb = {
                  metersource: this.form.deviceSource,
                  metertype: this.form.deviceType,
                  meterid: this.form.deviceId,
                  meterexid: this.form.deviceExId,
                  gatewayid: this.form.gatewayId
                }
                createDevice(meterDb).then((a) => console.log(a))
              }
              if (!alert(this.form.deviceSource + " account and device registration successful.")) { window.location.reload() }
            }
            else if (res.data.ReCode[0] == '35') {
              let content2 = {
                "AddPatientInfo": {
                  "API_Meth": "AddPatientDevice",
                  "pid": ("" + patient.externId).length == 7 ? "0" + patient.externId : "" + patient.externId,
                  "metertype": this.form.deviceType,
                  "meterexid": this.form.deviceExId + '',
                  "meterid": this.form.deviceId,
                  "gatewayid": this.form.gatewayId
                }
              }
              await axios.post(CURR_API + "/tswebhook.php", content2, { headers: { 'Content-Type': 'application/json;' } })
                .then((res) => {
                  if (res.data.ResultData) {
                    loader.hide()
                    loader = null
                    alert("Error: Please ensure that your device details are correct.")
                  }
                  else if (res.data.ReCode[0] == '00') {
                    let newMeter = {
                      metersource: this.form.deviceSource,
                      metertype: this.form.deviceType,
                      meterid: this.form.deviceId,
                      meterexid: this.form.deviceExId,
                      gatewayid: this.form.gatewayId
                    }
                    createDevice(newMeter).then((a) => console.log(a))
                    if (!alert(this.form.deviceSource + " device registration successful.")) { window.location.reload() }
                  }
                  else {
                    loader.hide()
                    loader = null
                    alert("Error: Please contact system administrator.")
                  }
                }, error => {
                  console.log(error)
                  loader.hide()
                  loader = null
                  alert("Error: " + res.data.ReMsg)
                })
            }
            else {
              loader.hide()
              loader = null
              alert("Error: Please contact system administrator.")
            }
          }, error => {
            console.log(error)
            loader.hide()
            loader = null
            alert("Error: Please contact system administrator.")
          })
      }
      else {
        loader.hide()
        loader = null
        alert("Error: Please select a device source.")
      }
    }
  }
}
</script>

<style scoped lang="scss">
$color-base: #0060ff;

.page {
  background-color: #fff;
  margin: 1.5rem auto;
  padding: 2.0rem;
  margin-bottom: 100px;
}

.row {
  flex-wrap: nowrap;
}

input,
select {
  font-size: 0.8rem;
}

.btn-container {
  margin-top: 1.0rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

.device__header,
.list__header {
  font-size: 2.5rem;
  color: $color-base;
  text-align: center;
  margin-top: 1.5rem;
  margin-bottom: 1em;
}

.device__label {
  font-size: 0.80rem;
  color: $color-base;
}

.btn-container {
  margin-top: 1.0rem;

  .btn {
    font-size: 0.8rem;
    margin: 2px;
  }

  padding-bottom: 3rem;
}

//   .device__info {
//       display: inherit;
//   }
.container .top-col {
  background: #646dc5;
}

.columntop {
  width: 75%;
  /*80%;*/
  display: flex;
  flex-direction: row;
  max-width: 1320px;
  text-align: center;
}

.columnrow {
  width: 75%;
  display: flex;
  flex-direction: row;
  max-width: 1320px;
  text-align: center;
}

.columnbottom {
  width: 100%;
  /*80%;*/
  display: flex;
  flex-direction: row;
  max-width: 1500px;
  text-align: center;
  justify-content: center;
  background-color: #98bfe1;
  color: #ffffff;
}

.pagnav a {
  color: #ffffff;
  margin-left: 10px;
}

.columntop span {
  color: #fff;
}

.toptitle h1 {
  text-align: center;
  color: #ffffff;
  font-size: 22px;
}

.toptitle {
  background-color: #0060ff;
}

.searchfindarea .container {
  display: flex;
  flex-direction: row;
}

.gridarea {
  width: 100%;
  height: auto;
}

.addPatientBtn {
  background-color: #165891;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  width: 220px;
}

.sharePatientBtn {
  background-color: #165891;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
  width: 220px;
}

.columnrow:nth-child(even) {
  background-color: #ffff;
}

.columnrow:nth-child(odd) {
  background-color: #98bfe1;
}

#notifyptchkbx {
  margin-right: 30px;
  margin-left: 10px;
}

// .top-row {
//   flex: inherit;
// }
.msboxwrapper {
  display: none;
  position: relative;
  top: -434px;
  width: 56%;
  height: auto;
  margin: 0px auto;
  /* display: flex;*/
  text-align: center;
  background-color: #ffff;
  border-radius: 9px;
}

.msboxwrapper .container {
  padding: 0px;
}

.mboxtitle {
  text-align: center;
}

.mboxtitle h2 {
  font-size: 17px;
  margin-top: 15px;
}

.msgbox {
  text-align: right;
  border-style: solid;
  border-width: 1px;
  border-color: #c0b6b6;
  background-color: #e0dddd;
  border-bottom-left-radius: 9px;
  border-bottom-right-radius: 9px;
}

.ptxtarea {
  width: 100%;
  height: 251px;
  border-style: none;
}

.modalbtn {
  background-color: #165891;
  color: #ffffff;
  font-size: 18px;
  width: 130px;
  height: 42px;
  margin-top: 20px;
  position: relative;
  right: 20px;
  border-radius: 8px;
}

.modalcancelbtn {
  background-color: #dee2e6;
  color: #000;
  width: 130px;
  height: 42px;
  margin-top: 20px;
  right: 40px;
  margin-right: 35px;
  border-radius: 8px;
}

.notemsglbl {
  width: 100%;
  height: 42px;
  display: none;
}

.notemsglbl.success {
  background-color: #8cf395;
  color: #ffffff;
  font-size: 18px;
  text-align: center;
}

#patientExtern,
#patientName {
  color: blue;
  cursor: pointer;
  text-decoration: underline;
}

.device__list {
  margin-bottom: 100px;
}

.meter__delete {
  border-radius: 20px;
  background-color: azure;
}

.no__devices {
  text-align: center;
}

.cpt-list {
  display: flex;
  flex-direction: column;
}
</style>